<template>
  <div>
    <v-dialog v-model="dialog" width="315">
      <template v-slot:activator="{ props }">
        <v-text-field
          v-bind="props"
          :rules="pickerRules"
          color="dark"
          v-on:input="selectText"
          v-model="selected"
          :append-icon="icons.includes(selected) ? selected : ''"
          :label="pickerTitle"
        ></v-text-field>
      </template>
      <v-card style="overflow-y: visible">
        <div class="flex-row" style="overflow-y: visible; height: auto">
          <div class="input-field line">
            <v-text-field
              :autofocus="autofocus"
              placeholder="Vyhledávání"
              v-model="query"
              prepend-icon="search"
              clearable
            ></v-text-field>
          </div>
          <v-divider></v-divider>
        </div>
        <div class="flex-row" style="overflow-y: scroll; height: 160px;">
          <div
            v-for="item in filteredIcons"
            :key="item"
            :id="`icon-${item}`"
            class="flex-cell"
            :class="{ selected: item === selection }"
            @click="preselect(item)"
          >
            <div class="iconbox">
              <i class="medium material-icons">{{ item }}</i>
            </div>
            <div class="caption">{{ item }}</div>
          </div>
        </div>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false">
            Zrušit
          </v-btn>
          <v-btn id="icon-picker-confirm" color="primary" text @click="select" :disabled="selection === ''">
            Vybrat
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script setup>
import { ref, computed, watch } from "vue";
import iconsData from "./icons.json";

/**
 * Input validation rules.
 */
const props = defineProps({
  rules: {
    type: Array,
    default: () => [],
  },
  /**
   * Input initial value.
   */
  initialValue: {
    type: String,
    default: "",
  },
  /**
   * Input title.
   */
  title: {
    type: String,
    default: "Ikona",
  },
  /**
   * Input autofocus.
   */
  autofocus: {
    type: Boolean,
    default: false,
  },
});

/**
 * Define the emitted events.
 */
const emit = defineEmits(["iconChanged"]);

const icons = ref(iconsData);

const dialog = ref(false);
const query = ref("");
const selection = ref(props.initialValue || "");
const selected = ref(props.initialValue || "");
const pickerTitle = ref(props.title);
const pickerRules = computed(() => [
  ...props.rules,
  (value) => icons.value.includes(value) || "Ikona s tímto názvem neexistuje",
]);

watch(() => props.initialValue, (newValue) => {
  selection.value = newValue || "";
  selected.value = newValue || "";
});

const preselect = (item) => {
  selection.value = item;
};

const select = () => {
  selected.value = selection.value;
  emit("iconChanged", selected.value);
  dialog.value = false;
};

const selectText = () => {
  if (icons.value.includes(selected.value)) {
    emit("iconChanged", selected.value);
  }
};

const filteredIcons = computed(() =>
  icons.value.filter((item) =>
    item.toLowerCase().includes(query.value.toLowerCase())
  )
);
</script>

<style scoped>
.line {
  width: 100%;
  margin: 10px 20px 0px 20px;
}

.flex-cell {
  display: flex;
  flex-flow: column;
  justify-content: center;
  flex: 0 1 100px;
  height: 80px;
  text-align: center;
  transition: 0.5s;
  max-width: 100px;
}

.flex-cell:hover {
  background-color: #f0f0f0;
  cursor: pointer;
  border-radius: 3px;
  transition: 0.2s;
}

.selected {
  background-color: #f0f0f0;
  border-radius: 3px;
  transition: 0.2s;
}

.flex-row {
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
}

.caption {
  padding: 2px;
  color: #757575;
  font-size: 11px;
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 0 10px;
}

.iconbox {
  word-wrap: break-word;
}
</style>
